import Card from "react-bootstrap/Card";

import { nameInitials } from "@/helpers";
import { lightOrDarkColor } from "@/utils/lightOrDarkColor";
import { getColorAttribute } from "@/utils/getColorAttribute";
import { SkeletonWrapper } from "../SkeletonWrapper";

type Props = {
	patientId?: number;
	patientName?: string;
	skeleton?: boolean;
};

export function Avatar({ patientId, patientName, skeleton = false }: Props) {
	return skeleton ? (
		<div className="d-flex justify-content-center py-6">
			<div className="rounded-circle bullet-30">
				<SkeletonWrapper circle height="100%" />
			</div>
		</div>
	) : (
		<div
			className="d-flex align-items-center justify-content-center rounded-circle bullet-30"
			style={{ background: getColorAttribute(patientId || 0) }}
		>
			<Card.Title
				className="fs-4 m-0"
				style={{ color: lightOrDarkColor(getColorAttribute(patientId || 0)) }}
			>
				{nameInitials(patientName || "")}
			</Card.Title>
		</div>
	);
}
